module.exports = "<div class=\"sidenav-backdrop backdrop\" (click)=\"closeHandler()\"></div>\n"